

















/* Created- 15 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ArticleTheme, IArticle } from "../../../Models/ArticleModels/article";
import { ArticleCountry } from "../../../Models/ArticleModels/article";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleThemes"
	})
export default class ArticleThemes extends Vue {
	@Prop() private value: IArticle;
	private newTheme: string = "";
	private themes: ArticleTheme[] = [];

	private mounted() {
		this.themes = this.value.themes;
	}

	private sendPropChanged(e: Event) {
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}

	private items(): ArticleTheme[] {

		const countries = Object.keys(ArticleCountry).reduce((arr: any[], key: any) => {
			if (!arr.includes(key)) {
				// @ts-ignore
				arr.push({ theme: ArticleCountry[key], id: 0, articleId: this.value.id } as ArticleTheme);
			}
			return arr as ArticleTheme[];
		}, []);
		return countries;
	}
}
